import { MapState } from './mapSlice';

export const mapReducers = {
  setEditorMode(
    state: MapState,
    action: { payload: MapState['editor']['mode'] },
  ) {
    state.editor.mode = action.payload;
    return state;
  },

  setEditorNode(
    state: MapState,
    action: {
      payload: MapState['editor']['node'];
    },
  ) {
    state.editor.node = action.payload;
    return state;
  },

  setEditorEdgeStartNode(
    state: MapState,
    action: {
      payload: MapState['editor']['edgeStartNode'];
    },
  ) {
    state.editor.edgeStartNode = action.payload;
    return state;
  },

  setEditorEdgeEndNode(
    state: MapState,
    action: {
      payload: MapState['editor']['edgeEndNode'];
    },
  ) {
    state.editor.edgeEndNode = action.payload;
    return state;
  },

  setEditorMoveNode(
    state: MapState,
    action: {
      payload: MapState['editor']['moveNode'];
    },
  ) {
    state.editor.moveNode = action.payload;
    return state;
  },

  setPaths(
    state: MapState,
    action: {
      payload: MapState['paths'];
    },
  ) {
    state.paths = action.payload;
    return state;
  },

  setHighlight(
    state: MapState,
    action: {
      payload: MapState['highlight'];
    },
  ) {
    state.highlight = action.payload;
    return state;
  },
};
